import { ElementTimingObserver } from './ElementTimingObserver';

// Экземпляр ElementTimingObserver
let elementTimingObserver: ElementTimingObserver | null = null;

/**
 * Получение экземпляра ElementTimingObserver.
 *
 * @kind helper
 * @returns Экземпляр ElementTimingObserver.
 */
export function getElementTimingObserver() {
    return elementTimingObserver;
}

/**
 * Установка экземпляра ElementTimingObserver.
 *
 * @kind helper
 * @param observer - Экземпляр ElementTimingObserver.
 */
export function setElementTimingObserver(observer: ElementTimingObserver) {
    elementTimingObserver = observer;
}

/**
 * Останавливает и удаляет экземпляр ElementTimingObserver.
 *
 * @kind helper
 */
export function cleanupElementTimingObserver() {
    elementTimingObserver?.stop();
    elementTimingObserver = null;
}
